import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, map } from 'rxjs';
import { AuthLoginService } from 'src/app/page/auth-page/service/auth-login.service';
import { ProfileService } from 'src/app/services/profile/profile.service';
import { ciTypesInterface } from 'src/app/util/interfaces/ciTypes';
import { genericFormInterface } from 'src/app/util/interfaces/genericForm';
import { environment } from 'src/environments/environment';

@Injectable({
	providedIn: 'root',
})
export class CiFieldService {
	private getAvailableCiTypesUrl = environment.baseApiUrl + 'cmdb/citype';
	private getCiFieldsUrl = environment.baseApiUrl + 'cmdb/citype/{idCiType}/field/{fieldLevel}';
	private postCiFieldsUrl = environment.baseApiUrl + 'cmdb/citype/{idCiType}/field/{fieldLevel}';
	private putCiFieldsUrl = environment.baseApiUrl + 'cmdb/citype/{idCiType}/field/{fieldLevel}';
	private deleteCiFieldsUrl = environment.baseApiUrl + 'cmdb/citype/{idCiType}/field/{fieldLevel}/{idField}';
	constructor(
		private http: HttpClient,
		private AuthLoginService: AuthLoginService,
		private ProfileService: ProfileService
	) {}

	getAvailableCiTypes(): Observable<ciTypesInterface[]> {
		const headers = new HttpHeaders({
			Authorization: 'Bearer ' + this.AuthLoginService.getSessionToken(),
			'Content-Type': 'application/json;charset=UTF-8',
		});
		return this.http.get<JSON[]>(this.getAvailableCiTypesUrl, { headers: headers }).pipe(
			map((ciTypesRes) => {
				const newCiTypesArray: ciTypesInterface[] = [];
				ciTypesRes.forEach((ciType: any) => {
					const newCiType: ciTypesInterface = {
						id: ciType.id,
						label: ciType.label,
						type: ciType.type,
						icon: ciType.icon,
					};

					newCiTypesArray.push(newCiType);
				});

				return newCiTypesArray;
			})
		);
	}

	getCiFields(idCiType: string, fieldLevel: 'cmdb' | 'ci' | 'customfield'): Observable<genericFormInterface[]> {
		const headers = new HttpHeaders({
			Authorization: 'Bearer ' + this.AuthLoginService.getSessionToken(),
			'Content-Type': 'application/json;charset=UTF-8',
		});
		if (!idCiType) idCiType = 'any';
		const getCiFieldsUrl = this.getCiFieldsUrl.replace('{idCiType}', idCiType).replace('{fieldLevel}', fieldLevel);
		return this.http.get(getCiFieldsUrl, { headers: headers }).pipe(
			map((ciFields: any) => {
				const newCiFields: genericFormInterface[] = [];

				for (const field of ciFields) {
					const newField: genericFormInterface = {
						id: field.id,
						label: field.label,
						name: field.field,
						required: field.required === 1,
						inputType: field.type,
						items: [],
						showOnCustomer: field.showOnCustomer,
						autoWriteFields: [],
						values: field.values ? field.values : [''],
						subfield_items: field.subfield,
					};

					if (field.autoWriteFields) {
						for (const autoWriteField of field.autoWriteFields) {
							newField.autoWriteFields.push(autoWriteField);
						}
					}

					newCiFields.push(newField);
				}

				return newCiFields;
			})
		);
	}

	createField(body: any, fieldLevel: 'cmdb' | 'ci' | 'customfield'): Observable<any> {
		const headers = new HttpHeaders({
			Authorization: 'Bearer ' + this.AuthLoginService.getSessionToken(),
			'Content-Type': 'application/json;charset=UTF-8',
		});
		const postCiFieldsUrl = this.postCiFieldsUrl.replace('{idCiType}', body.ci_type).replace('{fieldLevel}', fieldLevel);
		return this.http.post(postCiFieldsUrl, body, { headers: headers });
	}

	updateField(body: any, fieldLevel: 'cmdb' | 'ci' | 'customfield'): Observable<any> {
		const headers = new HttpHeaders({
			Authorization: 'Bearer ' + this.AuthLoginService.getSessionToken(),
			'Content-Type': 'application/json;charset=UTF-8',
		});
		const putCiFieldsUrl = this.putCiFieldsUrl.replace('{idCiType}', body.ci_type).replace('{fieldLevel}', fieldLevel);
		return this.http.put(putCiFieldsUrl, body, { headers: headers });
	}

	deleteField(ci_type: string, fieldLevel: string, idField: string): Observable<any> {
		const headers = new HttpHeaders({
			Authorization: 'Bearer ' + this.AuthLoginService.getSessionToken(),
			'Content-Type': 'application/json;charset=UTF-8',
		});
		const deleteCiFieldsUrl = this.deleteCiFieldsUrl
			.replace('{idCiType}', ci_type)
			.replace('{fieldLevel}', fieldLevel)
			.replace('{idField}', idField);
		return this.http.delete(deleteCiFieldsUrl, { headers: headers });
	}
}
